/**
 * Copyright Mántum All Rights Reserved.
 */
import Text from '../text';
import type { Exclude } from '@mantum/kanela';

type PropTypes = {
    advanced?: {
        clear?: {
            enabled?: boolean;
            exclude?: Exclude;
            title?: string;
        };
        filter?: {
            title?: string;
        };
    };
    onClear?: (exclude: Exclude) => void;
};

export default function Filter(props: PropTypes) {
    // prettier-ignore
    const {
        advanced = {}
    } = props;

    const onClear = () => {
        if (props.onClear) {
            props.onClear(advanced.clear?.exclude || {});
        }
    };

    return (
        <div className='flex items-center justify-end gap-2'>
            {advanced.clear && advanced.clear.enabled && (
                <Text onClick={onClear}>{advanced.clear.title || 'Clear'}</Text>
            )}
            <Text>{advanced?.filter?.title || 'Filter'}</Text>
        </div>
    );
}
